// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-KA9zwl","spin":"spin-iNVDUq"};